import { ButtonLink } from 'src/elements/Link'
import { orange, truewhite, _profilehrborder } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { flexCenter } from 'src/styles/mixins'
import styled from 'styled-components'

export const Layout = styled.div`
  ${flexCenter};
  flex-direction: column;
  max-width: min(80vw, 480px);
  padding: 10%;
  border-radius: 12px;

  background-color: ${truewhite};
  text-align: center;
  > * {
    margin: 10px;
  }
  h2 {
    width: 100%;
    padding-bottom: 20px;
    border-bottom: 1px solid ${_profilehrborder};
    font-size: 20px;
  }
  img {
    width: 100%;
    object-fit: contain;
    padding: 10%;
  }
  p {
    font-weight: ${fontWeightBold};
  }
`

export const PopUpButtonLink = styled(ButtonLink)`
  background: ${orange};
  color: ${truewhite};
  font-weight: ${fontWeightBold};
  padding: 10px 20px;
`
